import { render, staticRenderFns } from "./IconSelector.vue?vue&type=template&id=7e05cdd8&"
import script from "./IconSelector.vue?vue&type=script&lang=ts&"
export * from "./IconSelector.vue?vue&type=script&lang=ts&"
import style0 from "./IconSelector.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports